module.exports = __webpack_public_path__ + "static/media/approved-expert-bio.73dd7f92.png";